const HospitalPortalPlaceholder = ({ title, description }) => (
  <div className="hospital-portal-placeholder">
    <p>{description}</p>
    <p className="hospital-portal-placeholder__note">
      Content for <strong>{title}</strong> will be available here.
    </p>
  </div>
);

export const PatientQueriesScreen = () => (
  <HospitalPortalPlaceholder
    title="Patient Queries"
    description="Review patient questions and respond to inquiries from your hospital portal."
  />
);

export const DigitalCmeScreen = () => (
  <HospitalPortalPlaceholder
    title="Digital CME"
    description="Manage digital CME sessions, courses, and educational content."
  />
);
